export default "__VITE_ASSET__CmcMMWzY__"